{
  "heroTitle": "Invite your friends",
  "heroSub": "Every successful invite credits {{bonus}} to your bonus balance. When your friend deposits, {{percent}}% of that amount moves to your real balance after {{days}} days — withdraw anytime.",
  "yourLink": "Your invite link",
  "linkHint": "This is a Telegram bot link. When your friend opens it, they join the bot with your invite automatically.",
  "copy": "Copy",
  "copied": "Copied",
  "share": "Share",
  "more": "More",
  "shareText": "Join the VBB PLAY bot! Get {{bonus}} bonus per invite, plus {{percent}}% from your friend's deposits.",
  "infoTitle": "How it works",
  "infoSignup": "For every friend you invite you receive {{bonus}} on bonus balance immediately. It is only for bonus games — it is not mixed with real balance and cannot be withdrawn directly.",
  "infoBonusGames": "Bonus games: open Bonus games from the menu. Start a game with bonus funding. Wins stay on bonus balance until wagering rules are completed; regular real-money casino sessions do not spend this bonus.",
  "infoDeposit": "When your invited friend makes an approved deposit, {{percent}}% of that amount is recorded as your commission. Example: if a friend deposits {{exampleDeposit}}, you get {{exampleCommission}}.",
  "infoHold": "Deposit commission becomes real balance automatically after {{days}} days. Until then it shows as pending; after that it is withdrawable real money.",
  "infoWithdraw": "Once credited to real balance, you can withdraw via Cashier under the platform withdrawal rules.",
  "infoUnique": "Every player has a unique invite link. Self-referral is blocked.",
  "invitedLabel": "Invited",
  "friendsUnit": "friends",
  "earningsLabel": "Earnings from invites",
  "earningsSplit": "bonus {{bonus}} · real {{real}}",
  "earningsPending": "pending {{amount}} ({{days}} days)",
  "friendsTitle": "Your friends",
  "friendsCount": "{{count}} people",
  "friendsEmpty": "You haven't invited anyone yet",
  "friendId": "ID: {{id}}",
  "friendDeposit": "Deposit: {{amount}}",
  "friendEarned": "You earned: {{amount}}",
  "friendPending": "Pending: {{amount}}",
  "friendPendingUntil": "Moves to real on {{date}}",
  "loginRequired": "Sign in to see your invite link.",
  "navLabel": "Invite a friend"
}
